var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{class:{ 'error--text': _vm.errorColor }},[_c('base-markdown',{attrs:{"body":_vm.message}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }